<template>
  <div class="hello">
    <div class="tu-wen">

      <quill-editor class="sada" style="width:785px;height: 600px;position:absolute;left:0;top:176px;right:0;margin:auto;pvs" v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)" @change="onEditorChange($event)">
      </quill-editor>
    </div>
  </div>
</template>
<script>
  import {
    quillEditor
  } from 'vue-quill-editor'
  const toolbarOptions = [
    ['image'], // remove formatting button
  ]
  export default {
    data() {
      return {
        uploadRichTextImg: '', //上传图片地址接口
        content: '', //富文本里的内容
        editorOption: { //富文本编辑器的工具栏
          modules: {
            toolbar: {
              container: toolbarOptions, // 工具栏
              // handlers: {
              //   'image': function(value) { // 对图片进行改造，默认是通过base64 ,现通过iview 去传。
              //     if (value) {
              //     } else {
              //       this.quill.format('image', false);
              //     }
              //   }
              // }
            },
          },
          imageResize: {}, //自定义拉伸
          placeholder: '请输入文章内容',
        },
        contentTxt: '', //富文本编辑器里的前面100个文字
      }

    },

    created() {
      this.content = '<img src="https://api.pingyao888.cn/index/map/map.jpg"/>'
    },
    methods: {
      onEditorChange(e) {
        let _this = this;
        console.log(e.html);
        // _this.content = e.html; //标签以<p></p> 形式渲染 （重点）
        _this.contentTxt = e.text.substr(0, 100);
        console.log(_this.contentTxt)
      },
      // 富文本获取焦点事件
      onEditorFocus(e) {
      },
      // 富文本失去焦点事件
      onEditorBlur(e){
      },

      handleSuccessQuill(res) {
        console.log(res)
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, 'image', res.data.path)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          // 提示信息，需引入Message
         this.$message({
            duration:600,
            message:'图片上传失败',
            type:'error'
         })
        }
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue